// extracted by mini-css-extract-plugin
export default {"Container":"PopupSuccess_Container__LbLNH","Title":"PopupSuccess_Title__4wG7W","Subtitle":"PopupSuccess_Subtitle__A-kMd"};